import SignIn from "../../components/common/Signin";


type Props = {}

const LoginPage = (props: Props) => {
  return <SignIn />;
};

export default LoginPage;
